import { Component, Input } from '@angular/core';
import { AppliedReportOptions } from 'app/core/models/report.model';


@Component({
    selector: 'app-report-applied-boolean-option',
    templateUrl: './report-applied-boolean-option.component.html',
    imports: []
})
export class ReportAppliedBooleanOptionComponent {
  @Input() name;
  @Input() label;
  @Input() options: AppliedReportOptions;

  constructor() {}

  get value() {
    return this.options && this.options[this.name];
  }
}
